(() => {
  const init = (root) => {
    if (!root || root.dataset.fgcxReady === "true") return;
    root.dataset.fgcxReady = "true";

    const film = root.querySelector("[data-fgcx-film]");
    const video = film?.querySelector("video");
    const playButton = film?.querySelector("[data-fgcx-video-toggle]");
    const playLabel = playButton?.querySelector("[data-fgcx-video-label]");
    const playIcon = playButton?.querySelector(".fgcx__film-control-icon");
    const expandButton = film?.querySelector("[data-fgcx-video-expand]");
    const expandLabel = expandButton?.querySelector("[data-fgcx-expand-label]");

    if (!film || !video) return;

    const syncPlayback = () => {
      if (!playButton || !playLabel || !playIcon) return;
      const paused = video.paused;
      playLabel.textContent = paused ? "Play" : "Pause";
      playIcon.textContent = paused ? "▶" : "Ⅱ";
      playButton.setAttribute(
        "aria-label",
        `${paused ? "Play" : "Pause"} Fogatti manufacturing video`,
      );
    };

    const setExpanded = (expanded) => {
      film.classList.toggle("is-expanded", expanded);
      document.body.classList.toggle("fgcx-film-open", expanded);

      if (expandButton) {
        expandButton.setAttribute("aria-expanded", String(expanded));
        expandButton.setAttribute(
          "aria-label",
          `${expanded ? "Close expanded" : "Expand"} Fogatti manufacturing video`,
        );
      }
      if (expandLabel) expandLabel.textContent = expanded ? "Close" : "Expand";
    };

    playButton?.addEventListener("click", (event) => {
      event.stopPropagation();
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      syncPlayback();
    });

    expandButton?.addEventListener("click", (event) => {
      event.stopPropagation();
      setExpanded(!film.classList.contains("is-expanded"));
    });

    film.addEventListener("click", (event) => {
      if (event.target.closest("button, a")) return;
      setExpanded(!film.classList.contains("is-expanded"));
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && film.classList.contains("is-expanded"))
        setExpanded(false);
    });

    video.addEventListener("play", syncPlayback);
    video.addEventListener("pause", syncPlayback);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
      video.pause();
    syncPlayback();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-fgcx]").forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) =>
    initAll(event.target),
  );
})();

